export default "__VITE_ASSET__80da4092__"